export default {
list:[            
  // {
  //             img: 'https://qiniu.cxtrip.cc/tupian_57c858c9a6fafe450fc755a52.png',
  //             title:'广东流溪河国家森林公园总体规划',
  //             time:'时间: 2026年04月13日',
  //             detail:'附件PDF',
  //             url:[{
  //               name:'广东流溪河国家森林公园总体规划',
  //               url:'https://qiniu.cxtrip.cc/liuxihe/1%E6%B5%81%E6%BA%AA%E6%B2%B3%E5%9B%BD%E5%AE%B6%E6%A3%AE%E6%9E%97%E5%85%AC%E5%9B%AD%E6%80%BB%E4%BD%93%E8%A7%84%E5%88%92%E4%BF%AE%E7%BC%96%E2%80%94%E2%80%94%E9%99%84%E4%BB%B6.pdf'
  //             }]
  //         },
              {
              img: 'https://qiniu.cxtrip.cc/tupian_6fb265d5eb43462329ac35c5e.png',
              title:'2025年度广州市流溪河国家森林公园管理中心（广州市流溪河林场）部门决算',
              time:'时间: 2026年10月13日',
              detail:'',
              url:[{
                name:'2025年度广州市流溪河国家森林公园管理中心（广州市流溪河林场）部门决算.pdf',
                url:'https://qiniu.cxtrip.cc/liuxihe/2025%E5%B9%B4%E5%BA%A6%E5%B9%BF%E5%B7%9E%E5%B8%82%E6%B5%81%E6%BA%AA%E6%B2%B3%E5%9B%BD%E5%AE%B6%E6%A3%AE%E6%9E%97%E5%85%AC%E5%9B%AD%E7%AE%A1%E7%90%86%E4%B8%AD%E5%BF%83%EF%BC%88%E5%B9%BF%E5%B7%9E%E5%B8%82%E6%B5%81%E6%BA%AA%E6%B2%B3%E6%9E%97%E5%9C%BA%EF%BC%89%E9%83%A8%E9%97%A8%E5%86%B3%E7%AE%97.pdf'
              },{
                name:'2025年度广州市流溪河国家森林公园管理中心（广州市流溪河林场）非税收入征缴情况表.pdf',
                url:'https://qiniu.cxtrip.cc/liuxihe/2025%E5%B9%B4%E5%BA%A6%E5%B9%BF%E5%B7%9E%E5%B8%82%E6%B5%81%E6%BA%AA%E6%B2%B3%E5%9B%BD%E5%AE%B6%E6%A3%AE%E6%9E%97%E5%85%AC%E5%9B%AD%E7%AE%A1%E7%90%86%E4%B8%AD%E5%BF%83%EF%BC%88%E5%B9%BF%E5%B7%9E%E5%B8%82%E6%B5%81%E6%BA%AA%E6%B2%B3%E6%9E%97%E5%9C%BA%EF%BC%89%E9%9D%9E%E7%A8%8E%E6%94%B6%E5%85%A5%E5%BE%81%E7%BC%B4%E6%83%85%E5%86%B5%E8%A1%A8.pdf'
              }]
            },
            {
              img: 'https://qiniu.cxtrip.cc/tupian_6d0a1604b51e007de4a99c05d.png',
              title:'广州市人民政府关于禁止猎捕陆生野生动物的通告',
              time:'时间: 2026年07月08日',
              detail:'',
              url:[{
                name:'广州市人民政府关于禁止猎捕陆生野生动物的通告',
                url:'https://qiniu.cxtrip.cc/%E7%A9%97%E5%BA%9C%E8%A7%84%E3%80%942026%E3%80%952%E5%8F%B7%E3%80%8A%E5%B9%BF%E5%B7%9E%E5%B8%82%E4%BA%BA%E6%B0%91%E6%94%BF%E5%BA%9C%E5%85%B3%E4%BA%8E%E7%A6%81%E6%AD%A2.pdf'
              }]
            },
            {
              
              img: 'https://qiniu.cxtrip.cc/tupian_a7d1595b5830064aeebd15ad5.png',
              title:"公告",
              time:'时间: 2026年06月01日',
              detail:``,
              detail_url: 'https://qiniu.cxtrip.cc/tupian_a7d1595b5830064aeebd15ad5.png'
             
            },
           {
              img: 'https://qiniu.cxtrip.cc/tupian_86669bebdecb1e202b62cbba7.png',
              title:' ',
              time:'时间: 2026年04月13日',
              detail:'',
              url:[{
                name:'广东流溪河国家森林公园总体规划',
                url:'https://qiniu.cxtrip.cc/liuxihe/%E6%B5%81%E6%BA%AA%E6%B2%B3%E5%9B%BD%E5%AE%B6%E6%A3%AE%E6%9E%97%E5%85%AC%E5%9B%AD%E6%80%BB%E4%BD%93%E8%A7%84%E5%88%9220190521-1.pdf'
              }]
          },
          //   {
          //     img: 'https://qiniu.cxtrip.cc/tupian_8ea11f6175ca435b18357141e.png',
          //     title:'流溪河图集',
          //     time:'时间: 2026年04月13日',
          //     detail:'附件PDF',
          //     url:[{
          //       name:'流溪河图集',
          //       url:'https://qiniu.cxtrip.cc/liuxihe/%E6%B5%81%E6%BA%AA%E6%B2%B3%E5%9B%BE%E9%9B%8620190510%E5%85%A8%EF%BC%88%E6%94%B9%EF%BC%89.pdf'
          //     }]
          // },
      {
              img: require('@/newsData/list/2026-0210-01/01-T.png'),
              title:'2026年广州市流溪河国家森林公园管理中心（广州市流溪河林场）部门预算',
              time:'时间: 2026年02月10日',
              detail:'',
              url:[{
                name:'2026年广州市流溪河国家森林公园管理中心（广州市流溪河林场）部门预算',
                url:require('@/newsData/list/2026-0210-01/01.pdf')
              }]
          },
      {
              img: require('@/newsData/list/2026-0207-01/01-T.png'),
              title:'2024年度广州市流溪河国家森林公园管理中心（广州市流溪河林场）部门决算',
              time:'时间: 2025年10月14日',
              detail:'',
              url:[{
                name:'2024年度广州市流溪河国家森林公园管理中心（广州市流溪河林场）部门决算',
                url:require('@/newsData/list/2026-0207-01/01.pdf')
              }]
          },    
          {
              img:'https://www.lxhpark.cn/img/2024-10-15-01.jpg',
              title:'2025年广州市流溪河国家森林公园管理中心（广州市流溪河林场）部门预算 ',
              time:'时间: 2025年3月12日',
              detail:'',
              url:[{
                name:'2025年广州市流溪河国家森林公园管理中心（广州市流溪河林场）部门预算.pdf',
                url:require('@/assets/file/2025-03-12-01.pdf')
              },{
                name:'广州市流溪河国家森林公园管理中心（广州市流溪河林场）2025年项目支出绩效目标表（含转移支付项目）',
                url:require('@/assets/file/2025-03-12-02.pdf')
              }]
          },
          {
              
              img: require('@/assets/imgs/all/2025-0416-03-01.png'),
              title:"联学共建悟精神，携手并进促发展",
              time:'时间: 2025年4月16日',
              detail:``,
              detail_url: require('@/assets/imgs/all/2025-0416-03-02.png')
             
            },
            {
              
              img: require('@/assets/imgs/all/2025-0416-02-01.png'),
              title:"广州市流溪河林场举办古树名木保护专题培训",
              time:'时间: 2025年4月16日',
              detail:``,
              detail_url: require('@/assets/imgs/all/2025-0416-02-02.png')
             
            },
            {
              
              img: require('@/assets/imgs/all/2025-0416-01-01.png'),
              title:"广州海事局到流溪河国家森林公园开展安全生产检查",
              time:'时间: 2025年4月16日',
              detail:``,
              detail_url: require('@/assets/imgs/all/2025-0416-01-01.png')
             
            },
            {
              
              img: require('@/assets/imgs/all/2025-0411-01-01.png'),
              title:"广州市流溪河国家森林公园管理中心赴广州市生态环境局从化分局对接协调森林公园经营发展及生态环保工作",
              time:'时间: 2025年4月11日',
              detail:``,
              detail_url: require('@/assets/imgs/all/2025-0411-01-02.png')
             
            },
            {
              
              img: require('@/assets/imgs/all/2025-0327-02-01.png'),
              title:"聚焦引领区建设 共谋发展新篇章",
              time:'时间: 2025年3月27日',
              detail:``,
              detail_url: require('@/assets/imgs/all/2025-0327-02-02.png')
             
            },
            {
              
              img: require('@/assets/imgs/all/2025-0325-01-01.png'),
              title:"开展垃圾分类培训 助力绿色环保新风尚",
              time:'时间: 2025年3月25日',
              detail:``,
              detail_url: require('@/assets/imgs/all/2025-0325-01-02.png')
             
            },
          {
              
              img: require('@/assets/imgs/all/2025-03-18-01-01.png'),
              title:"从化区委副书记、区长赵龙到广州市流溪河国家森林公园调研",
              time:'时间: 2025年3月18日',
              detail:``,
              detail_url: require('@/assets/imgs/all/2025-03-18-01-02.png')
             
            },
          {
              
              img: require('@/assets/imgs/all/2025-03-06-01-02.png'),
              title:"广州市从化区人民检察院公益诉讼观察站在广州市流溪河国家森林公园挂牌成立",
              time:'时间: 2025年3月6日',
              detail:``,
              detail_url: require('@/assets/imgs/all/2025-03-06-01-01.png')
             
            },
            {
              
              img: require('@/assets/imgs/all/2025-03-05-01-02.png'),
              title:"流溪河国家森林公园管理中心荣获广州市从化区2024年度无偿献血工作突出集体称号",
              time:'时间: 2025年3月5日',
              detail:``,
              detail_url: require('@/assets/imgs/all/2025-03-05-01-01.png')
             
            },
          {
              
            img: require('@/assets/imgs/all/20250225-01-02.png'),
            title:"广州市流溪河国家森林公园管理中心召开森林防火和安全生产工作专题会议",
            time:'时间: 2025年2月25日',
            detail:``,
            detail_url: require('@/assets/imgs/all/20250225-01-01.png')
           
          },
          {
              
              img: require('@/assets/imgs/all/20250220-01-02.png'),
              title:"从化区副区长徐东川到流溪河国家森林公园调研",
              time:'时间: 2025年2月20日',
              detail:``,
              detail_url: require('@/assets/imgs/all/20250220-01-01.png')
             
            },
            {
              
              img: require('@/assets/imgs/all/20250219-01-02.png'),
              title:"良口镇供电所到流溪河林场调研",
              time:'时间: 2025年2月19日',
              detail:``,
              detail_url: require('@/assets/imgs/all/20250219-01-01.png')
             
            },
            {
              
              img: require('@/assets/imgs/all/20250218-01-02.png'),
              title:"市财政局预算编审处到市流溪河国家森林公园管理中心调研高质量运营发展工作",
              time:'时间: 2025年2月18日',
              detail:``,
              detail_url: require('@/assets/imgs/all/20250218-01-02.png')
             
            },
            {
              
              img: require('@/assets/imgs/all/20250207-01-02.png'),
              title:"从化区副区长徐东川到流溪河林场调研",
              time:'时间: 2025年2月07日',
              detail:``,
              detail_url: require('@/assets/imgs/all/20250207-01-01.png')
             
            },
            {
              
              img: require('@/assets/imgs/all/20250207-01-02.png'),
              title:"广州市流溪河国家森林公园管理中心开展节后森林防火和安全生产工作",
              time:'时间: 2025年2月16日',
              detail:``,
              detail_url: require('@/assets/imgs/all/20250207-01-01.png')
             
            },
          {
              img:'https://www.lxhpark.cn/img/2024-10-15-01.jpg',
              title:'广州市流溪河国家森林公园管理中心部门决算',
              time:'时间: 2024年10月15日',
              detail:'附件PDF',
              url:[{
                name:'2023年广州市流溪河国家森林公园管理中心部门决算.pdf',
                url:'https://www.lxhpark.cn/img/2024-10-15-02.pdf'
              },{
                name:'附件：2023年度广州市流溪河国家森林公园管理中心非税收入征缴情况表.pdf',
                url:'https://www.lxhpark.cn/img/2024-10-15-03.pdf'
              }]
           
          },{
            img:'https://qiniu.cxtrip.cc/tupian_2a2001c0a20ddbd76603b59ab.png',
            title:'广州市流溪河国家森林公园管理中心',
            subTitle:'2019-2021年财务状况说明',
            time:'时间: 2024年04月16日',
            detail:``
          },
          {
              img:'https://qiniu.cxtrip.cc/tupian_a7a5b22fb0fdbea5154588704.png',
              title:'巡察公告',
              time:'时间: 2024年04月11日',
              detail:'附件PDF',
              url:[{
                name:'巡察公告(扫描版).pdf',
                url:'https://qiniu.cxtrip.cc/2bb7189b6e16cfa8f1a18c51217aeab3_43314a40b0259e4b6e0cb7a32ba0c465_8.pdf'
              }]
          },
          {
              img:'https://qiniu.cxtrip.cc/tupian_475e61277916d90f62603c824.png',
              title:'广州市流溪河国家森林公园管理中心（广州市流溪河林场）部门预算',
              time:'时间: 2023年02月22日',
              detail:'附件PDF',
              url:[{
                name:'广州市流溪河国家森林公园管理中心（广州市流溪河林场）2024年项目支出绩效目标表（含转移支付项目）.pdf',
                url:'https://qiniu.cxtrip.cc/%E5%B9%BF%E5%B7%9E%E5%B8%82%E6%B5%81%E6%BA%AA%E6%B2%B3%E5%9B%BD%E5%AE%B6%E6%A3%AE%E6%9E%97%E5%85%AC%E5%9B%AD%E7%AE%A1%E7%90%86%E4%B8%AD%E5%BF%83%EF%BC%88%E5%B9%BF%E5%B7%9E%E5%B8%82%E6%B5%81%E6%BA%AA%E6%B2%B3%E6%9E%97%E5%9C%BA%EF%BC%892024%E5%B9%B4%E9%A1%B9%E7%9B%AE%E6%94%AF%E5%87%BA%E7%BB%A9%E6%95%88%E7%9B%AE%E6%A0%87%E8%A1%A8%EF%BC%88%E5%90%AB%E8%BD%AC%E7%A7%BB%E6%94%AF%E4%BB%98%E9%A1%B9%E7%9B%AE%EF%BC%89.pdf'
              },{
                name:'2024年广州市流溪河国家森林公园管理中心（广州市流溪河林场）部门预算.pdf',
                url:'https://qiniu.cxtrip.cc/2024%E5%B9%B4%E5%B9%BF%E5%B7%9E%E5%B8%82%E6%B5%81%E6%BA%AA%E6%B2%B3%E5%9B%BD%E5%AE%B6%E6%A3%AE%E6%9E%97%E5%85%AC%E5%9B%AD%E7%AE%A1%E7%90%86%E4%B8%AD%E5%BF%83%EF%BC%88%E5%B9%BF%E5%B7%9E%E5%B8%82%E6%B5%81%E6%BA%AA%E6%B2%B3%E6%9E%97%E5%9C%BA%EF%BC%89%E9%83%A8%E9%97%A8%E9%A2%84%E7%AE%97.pdf'
              }]
           
          },
              {
                img:'https://hi.cxtrip.cc/cxyTicket/lxh/xinwen/xinwen4.png',
                title:'广州市流溪河林场更新单元详细规划社会稳定风险评估公众参与信息公示',
                time:'时间: 2023年7月24日',
                detail:`根据《国家发展改革委关于印发重大固定资产投资项目社会稳定风险评估暂行办法的通知》（发改投资[2012]2492号）、《广东省发展改革委重大项目社会稳定风险评估暂行办法》（粤发改重点[2012]1095 号）等文件的要求，现对《广州市流溪河林场更新单元详细规划》信息进行公示，征询该调整事项社会稳定风险的意见和建议。
`,    
                firstPart:`一、项目概况
                            （一）规划范围
                流溪河国家森林公园是位于广东省广州市从化区的生态型公园，公园总面积8932.31公顷。流溪河林场更新详细规划审查专项所涉及的规划范围为流溪河国家森林公园(除东星村、谷星村、温塘肚村)，总面积约6819.50公顷。其中城市更新单元范围暂按初步成果中划定的单元面积295公顷计算。最终上报范围以广州市城乡规划和自然资源主管部门指导为准。
                （二）规划定位
                由工区向小镇转变，游览式向参与式转变单一游览功能向综合提升造血能力转变，定位为珠三角北部生态涵养地、羊城最洁水源地、南亚热带森林天堂广州市生态文明教育示范基地、自然课堂国家森林特色小镇以森林体验和森林养生为主的“绿色养生谷森林康养第一镇、国际森林康养基地国家AAAA级旅游景区。
                （三）功能定位
                “森林+森林旅游”：森林生态观光、森林拓展训练、森林露营体验、森林休憩娱乐
                “森林+森林康养”：森林体育康养、森林养老康养、森林医疗康养、森林教育康养
                “森林+自然教育”：森林研学教育、自然文化科普、文化艺术交流、爱国文化教育
                “森林+林下经济”：药材、林果茶叶种植、高端养殖、野生采摘、农产品加工
                （四）规划结构
                规划“三个单元、四类分区”，“三个单元”为北部生态单元、森林康养小镇城镇建设单元、五指山生态单元；“四个分区”为森林旅游区、森林康养区、自科教育区、生态保育区。
                三个单元、四类分区`,
                secPart:`
                二、社会稳定风险的评估工作程序和工作内容
                1、对项目风险调查、风险识别的过程和方式方法进行评估。
                2、对项目建设的合理性、合法性、可行性和可控性进行评估。
                3、对项目可能导致社会稳定风险产生的因素进行评估。
                4、对项目的社会稳定风险进行评级，提出改进措施或项目实施建议。`,
                thrPart:`三、征求公众意见的主要范围及事项
                1、项目对当地社会及经济发展的影响；
                2、项目对公民个人或家庭自身利益的影响；
                3、项目可能产生的安全因素与自身利益的影响；
                4、项目可能产生的环境因素与自身利益的影响；
                5、对本项目的态度；
                6、公众关心的其他相关问题。`,
                fourPart:`四、公示说明
                1、公示时间：2023年7月24日—2023年7月30日止，共7天。
                2、公示期间，如对本项目有社会稳定风险方面的意见或建议，可通过电话、电子邮件向评估单位提出。`,
                fivePart:`五、联系方式
                评估单位：重庆交通大学工程设计研究院有限公司
                联 系 人：黄小姐        联系电话：13809241014
                邮 箱：huangdingyi2021@163.com
                您的意见和建议对本项目具有积极作用，我们在此对您表示真挚的感谢！`,
              },
              {
              img:'https://hi.cxtrip.cc/cxyTicket/lxh/xinwen/xinwen2.jpg',
              title:'从化区副区长廖绮晶到流溪河林场督导检查水上交通安全生产工作',
              time:'时间: 2023年6月7日',
              detail:`6月7日上午，从化区副区长廖绮晶带队到流溪河林场督导检查水上交通安全生产工作。从化区府办、区交通运输局、区公安分局、区应急管理局、区消防大队、区农业农村局、区文广旅体局、良口镇政府、流溪河林场相关负责同志陪同。
廖绮晶副区长仔细听取了流溪河林场水上交通安全治理工作开展情况汇报，并检查了工作台帐，随后到流溪河水库进行实地检查。廖绮晶副区长充分肯定了流溪河林场水上交通安全治理工作，并提出了三点工作要求：一是各相关责任部门单位要切实提高思想认识和政治站位，认真贯彻执行人民至上，生命至上的安全生产发展理念；二是各部门单位按职责分工，各司其职，形成合力，齐抓共管，强化风险隐患排查，加强宣传和库区巡查；三是采取有效措施，开展水上安全联合整治行动，共同打击水上违法行为，消除水上各类风险隐患，确保人民群众生命财产安全，促进流溪河水库水上交通安全形势向好发展。
`
          },{
            img:'https://hi.cxtrip.cc/cxyTicket/lxh/xinwen/xinwen1.jpg',
              title:'市林业园林局党组书记、局长蔡胜到流溪河国家森林公园管理中心调研',
              time:'时间: 2023年5月28日',
              detail:`5月28日，市林业园林局党组书记、局长蔡胜到流溪河国家森林公园管理中心走访调研。市林业园林局总工程师粟娟，办公室、营造林管理处和服务监督处有关负责同志及流溪河国家森林公园管理中心党政主要负责同志陪同。蔡胜局长听取了管理中心关于绿美广州生态建设、信访维稳、安全生产等工作的情况汇报，随后提出了七点工作意见：一是深入学习领会习近平总书记重要讲话精神，认真贯彻党中央关于开展主题教育的部署要求，以高度政治责任感和求真务实作风，推动主题教育不断向纵深发展；二是始终紧绷安全生产这根弦，强化责任意识、全面排查隐患、抓好重点区域、夯实安全基础，有效防范遏制各类生产安全事故发生；三是严格落实“三防”责任制和24小时值班值守制度，强化巡查监控，密切关注汛情，确保安全度汛；四是深入推进绿美广州生态建设，以“护水、连山、串景、融育”为主线奋力打造绿美广州生态建设北部示范点，为广州市实现老城市新活力、“四个出新出彩”增添生态底色；五是以满足人民日益增长的美好生活需要为出发点和落脚点，继续紧抓电网改造移交、天然气管网建设、供水改造等民生实事，用心用情解决群众急难愁盼的历史遗留问题，把发展成果不断转化为生活品质，不断提升人民群众获得感、幸福感、安全感；六是以群众需求为导向，通过自然教育基地和森林康养基地建设加快推进森林公园建设的步伐，精心塑造多色彩特色森林景观，开放公园绿地草坪，拉近生态文明建设和群众日常生活之间的距离，真正让群众共享生态文明建设成果；七是要树牢以人民为中心的发展思想，畅通和规范群众诉求表达通道，依法依规、公平公正解决群众合理诉求，把矛盾纠纷处理在初发阶段、化解在萌芽状态，为高质量发展营造和谐稳定的社会环境。`
          },{
            img:'https://hi.cxtrip.cc/cxyTicket/lxh/xinwen/xinwen3.jpg',
              title:'市林业园林局一级调研员（市管）梁湛涛到流溪河国家森林公园管理中心调研',
              time:'时间: 2023年5月25日',
              detail:`5月25日，市林业园林局一级调研员（市管）梁湛涛到流溪河国家森林公园管理中心调研。市林业园林局服务监督处，流溪河国家森林公园管理中心领导陪同。
梁湛涛同志一行到森林公园景区了解草坪开放情况，随后听取了管理中心近期信访工作的汇报。梁湛涛同志对管理中心工作提出了三点意见：一是要做好公园草坪开放准备工作，落实厕所、垃圾桶、水电等基本配套设施建设，更好地满足游客亲近自然、休闲游憩的需求；二是要始终把安全生产摆在工作的重中之重，持续深入开展安全隐患排查整治，牢牢守住安全生产底线，坚决遏制各类事故发生；三是要常态长效推进信访问题源头治理和信访积案化解，及时了解问题、破解难题，真正把矛盾纠纷化解在基层、解决在当地，切实维护社会大局和谐稳定。
`
          }],
}